export const MESSAGES = Object.freeze({
  // error
  LOGIN_FAILED: 'ログインに失敗しました。',
  SAVE_FAILED: '保存に失敗しました。',
  TEMPLATE_CONFLICT: 'このテンプレートはすでに登録されています。',
  INSUFFICIENT: '未入力項目があります。',
  LOGIN_FORBIDDEN: 'このユーザーのログインは許可されていません。',
  USER_NOT_FOUND: 'ユーザーが見つかりませんでした。',
  USER_ADD_FAILED: 'アカウント作成に失敗しました',
  NO_ACCOUNT_IN_CSV: 'CSVファイル内にアカウントがみつかりません',

  // info
  NOTICE_SUBMITTED: '通告を送信しました。「通告送信履歴」から確認できます。',
  TEMPLATE_CREATED: 'テンプレートを登録しました。続けて、別のテンプレートを登録できます。',
  TEMPLATE_APPLIED: '選択したテンプレートの内容を入力しました。',
  TRAINER_CHECK_RESULT_CREATED: '指導者チェックを登録しました。',
  TRAINER_CHECK_ITEMS_UPDATED: '指導者チェック項目を更新しました。',
  SELF_CHECK_ITEMS_UPDATED: '受講者セルフチェック問題を更新しました。',
  ACCOUNT_ADDED: 'アカウントを登録しました。続けて、別のアカウントを登録できます。',
  ACCOUNT_UPDATED: 'アカウントを更新しました。',
  ACCOUNT_DELETED: 'アカウントを削除しました。',
});
